import { render, staticRenderFns } from "./ExhibitionList.vue?vue&type=template&id=c0608a66&scoped=true"
import script from "./ExhibitionList.vue?vue&type=script&lang=js"
export * from "./ExhibitionList.vue?vue&type=script&lang=js"
import style0 from "./ExhibitionList.vue?vue&type=style&index=0&id=c0608a66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0608a66",
  null
  
)

export default component.exports